import { Chip, Grid } from '@material-ui/core';
import { createStyles } from '@material-ui/core/styles';
import * as React from 'react';
import { compose } from 'recompose';
import { withBaseProps } from '../../Utils';
const styles = (theme) => createStyles({
    chip: {
        '&, &:focus, &:hover': {
            background: theme.color.grey.default,
            color: theme.color.font.light,
        },
    },
});
const AutocompleteChipList = ({ classes, items, onDelete, testId = 'AutocompleteChipList', }) => {
    return (React.createElement(Grid, { container: true, spacing: 1, "data-testid": `${testId}` }, items.map((item) => (React.createElement(Grid, { item: true, key: item.label || item.value, xs: "auto" },
        React.createElement(Chip, { "data-testid": `${testId}-${item.label}`, classes: { root: classes.chip }, color: "secondary", label: item.label || '', onDelete: () => onDelete(item) }))))));
};
export default compose(withBaseProps({ styles }))(AutocompleteChipList);
//# sourceMappingURL=AutocompleteChipList.js.map